module.exports = {
    DELAY: 500,
};
